import React from 'react';

export const AuthHeader = ({ ballot }) => {
    return (
        <div className="text-center">
            {!ballot &&
                <img src="/img/logo.png" className="mx-auto mb-8 max-h-24" title="TrueVote" alt="TrueVote" />
            }
            {ballot &&
                <React.Fragment>
                    <img src={ballot.orgLogo} className="mx-auto mb-4 max-h-32" title={ballot.orgName} alt={ballot.orgName} />
                    <p className="mb-4 text-xl font-bold">{ballot.orgName}</p>
                </React.Fragment>
            }
            <p className="mb-4 text-3xl font-bold">Welcome to TrueVote</p>
        </div>
    );
}